import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"

import { isEditUserSettingsSitesDrawer, isOpenUserSettingsSitesDrawer, userSettingSitesFormData } from "../../../@signals"
import UserSettingSiteDrawerColor from "./Color"
import UserSettingSiteDrawerSites from "./Sites"
import UserSettingSiteDrawerSubmit from "./Submit"


export default function UserSettingSiteDrawer() {

	return <DrawerSeeker
		hideActions
		title={isEditUserSettingsSitesDrawer.value ? 'Edit site' : 'New site'}
		isOpen={isOpenUserSettingsSitesDrawer.value}
		controller={() => userSettingSitesFormData.value = { }}
		successText="save"
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<UserSettingSiteDrawerSites />
			</Grid>

			<Grid item xs={12}>
				<UserSettingSiteDrawerColor />
			</Grid>

			<Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
				<UserSettingSiteDrawerSubmit />
			</Grid>
		</Grid>
	</DrawerSeeker>
}